import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import { __rest as t } from "../_virtual/_tslib.js";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { calculateRem as n, aspectRatioPolyfill as r, getBrowser as i, getOS as a, generateUUID as s, checkIfMobileDevice as c } from "@vds-core/utilities";
import { AccessibilityTokens as d } from "@vds-tokens/accessibility";
import { ColorTokens as u } from "@vds-tokens/color";
import { LayoutTokens as l } from "@vds-tokens/layout";
import { createElement as h, Component as p } from "react";
import g, { css as $ } from "styled-components";
var v = function v(t) {
    return t ? t.replace(":", "/") : void 0;
  },
  f = g(function (e) {
    var o = e.primitive,
      n = t(e, ["primitive"]);
    return h(o, n);
  }).withConfig({
    displayName: "OuterButton",
    componentId: "VDS__sc-61pwns-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline: none;\n  display: flex;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  color: transparent;\n  ", "\n  &:active {\n    ", "\n    &::before {\n      ", "\n    }\n  }\n"])), function (_ref) {
    var t = _ref.$isInteractive,
      e = _ref.surface,
      o = _ref.$hovered;
    return t && !o && "\n  &:focus-visible:not(:active, :hover) {\n    &::before { \n      border: ".concat(n(d.focusring.borderwidth.value), " ").concat(d.focusring.borderstyle.value, ";\n      border-color: ").concat("light" === e ? d.color.focusring.onlight.value : d.color.focusring.ondark.value, ";\n      border-radius: 14px;\n      content: '';\n      left: 50%; \n      position: absolute;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: calc(100% + 6px);\n      height: calc(100% + 6px);\n    }\n    }\n");
  }, function (_ref2) {
    var t = _ref2.$isInteractive;
    return t && "cursor: pointer;";
  }, function (_ref3) {
    var t = _ref3.$mobile,
      e = _ref3.$isInteractive,
      o = _ref3.surface,
      n = _ref3.$active;
    return e && !t && n && "\n        content: '';\n        left: 50%; \n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: 100%;\n        height: 100%;\n        border-radius: ".concat(l.shape.cornerradius.tiles.value, ";\n        background-color: ").concat("light" === o ? "".concat(u.palette.white.value) : "".concat(u.palette.black.value), ";\n        opacity: 30%;\n        z-index: 1;\n      ");
  }),
  b = g.div.withConfig({
    displayName: "OuterMostWrapper",
    componentId: "VDS__sc-61pwns-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  outline: none;\n  position: relative;\n  transition: 0.2s;\n  width: ", ";\n  ", ";\n  ", "\n"])), function (_ref4) {
    var t = _ref4.width;
    return t;
  }, function (_ref5) {
    var t = _ref5.height;
    return "100%" === t ? "height: 100%" : "";
  }, function (_ref6) {
    var t = _ref6.$isInteractive,
      e = _ref6.$mobile,
      o = _ref6.surface,
      n = _ref6.$hovered,
      r = _ref6.$showDropShadow,
      i = _ref6.$shadowStrong;
    return t && n && !e && "\n      transform: scale(1.02) translate(0, 0) perspective(1px);\n      cursor: pointer;\n      z-index: 2;\n      ".concat("light" === o && r ? $(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n              > div:last-of-type {\n                box-shadow: ", ";\n            "])), i ? "0px 6px 24px 0px rgba(0, 0, 0, 0.1)" : "0 16px 24px rgba(0, 0, 0, 0.04)") : "", "\n      \n  ");
  }),
  m = g.div.withConfig({
    displayName: "InnerTileContainer",
    componentId: "VDS__sc-61pwns-2"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  outline: none;\n  display: flex;\n  width: ", ";\n  ", ";\n"])), function (_ref7) {
    var t = _ref7.width;
    return t;
  }, function (_ref8) {
    var t = _ref8.padding,
      e = _ref8.$showBorder,
      o = _ref8.$isIos,
      n = _ref8.$isChrome,
      r = _ref8.$isSafari,
      i = _ref8.$grouped;
    return i && (r || o && n) && "\n      height: calc(100% - ".concat(t, " - ").concat(t, " - ").concat(e ? "2px" : "0px", ")\n  ");
  }),
  w = $(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  align-items: unset;\n  background-color: ", ";\n  border: ", ";\n  background: ", ";\n  height: ", ";\n  width: ", ";\n  ", ";\n\n  border-radius: ", ";\n  position: relative;\n  box-sizing: border-box;\n  padding: ", ";\n  outline: none;\n  box-shadow: ", ";\n"])), function (_ref9) {
    var t = _ref9.$backgroundImage;
    return void 0 !== t && "" !== t ? "background-image: ".concat("none" === t ? "none" : "url(".concat(t, ")"), ";") : "";
  }, function (_ref0) {
    var t = _ref0.$backgroundColor,
      e = _ref0.surface,
      o = _ref0.$imageFallbackColor,
      n = _ref0.$backgroundImage;
    return n ? "light" === o ? u.background.primary.light.value : u.background.primary.dark.value : function (t, e) {
      return "white" === t ? u.palette.white.value : "black" === t ? u.palette.black.value : "secondary" === t ? u.background.secondary["".concat(e)].value : "primary" === t ? u.background.primary["".concat(e)].value : t;
    }(t, e);
  }, function (_ref1) {
    var t = _ref1.surface,
      e = _ref1.$showBorder;
    return e ? "light" === t ? "1px solid ".concat(u.elements.lowcontrast.onlight.value) : "1px solid ".concat(u.elements.lowcontrast.ondark.value) : "none";
  }, function (_ref10) {
    var t = _ref10.background;
    return t;
  }, function (_ref11) {
    var t = _ref11.height;
    return t;
  }, function (_ref12) {
    var t = _ref12.width;
    return t;
  }, function (_ref13) {
    var t = _ref13.$aspectRatio,
      e = _ref13.height;
    return !e && "\n      aspect-ratio: ".concat(v(t), ";\n      ").concat(r(v(t)), ";\n    ");
  }, l.shape.cornerradius.tiles.value, function (_ref14) {
    var t = _ref14.padding;
    return t;
  }, function (_ref15) {
    var t = _ref15.surface,
      e = _ref15.$showDropShadow,
      o = _ref15.$shadowStrong;
    return e && "light" === t ? o ? "0px 6px 24px 0px rgba(0, 0, 0, 0.1)" : "0 16px 24px rgba(0, 0, 0, 0.02)" : void 0;
  }),
  k = g.div.withConfig({
    displayName: "OuterTileContainer",
    componentId: "VDS__sc-61pwns-3"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  text-align: left;\n  pointer-events: none; // Have to set none here so the tile is clickable\n"])), w);
var x = /*#__PURE__*/function (_p) {
  _inherits(x, _p);
  function x(t) {
    var _this;
    _classCallCheck(this, x);
    var e;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(x).call(this, t)), e = _assertThisInitialized(_assertThisInitialized(_this)), _this.isSafari = "safari" === i(), _this.isChrome = "chrome" === i(), _this.isIos = "ios" === a(), _this._setHovered = function (t) {
      return e.setState({
        hovered: t
      });
    }, _this._onKeyDown = function (t) {
      if ("Enter" === t.key || " " === t.key) {
        (document && document.getElementById("OuterButton-".concat(e.tileContainerId))) === t.target && e._onClick(t);
      }
    }, _this._onMouseDown = function (t) {
      var o = document && document.getElementById("OuterButton-".concat(e.tileContainerId));
      o && (t.target !== o || e.state.active || e.setState({
        active: !0
      }));
    }, _this._onMouseUp = function () {
      e.state.active && e.setState({
        active: !1
      });
    }, _this._onClick = function (t) {
      var o = e.props.onClick;
      o && o(t);
    }, _this.state = {
      active: !1,
      hovered: !1
    }, _this.tileContainerId = t.id ? t.id : s();
    return _this;
  }
  _createClass(x, [{
    key: "render",
    value: function render() {
      var t = this;
      var _this$props = this.props,
        n = _this$props.backgroundColor,
        r = _this$props.imageFallbackColor,
        i = _this$props.background,
        a = _this$props.height,
        s = _this$props.width,
        d = _this$props.aspectRatio,
        u = _this$props.children,
        l = _this$props.surface,
        h = _this$props.onClick,
        p = _this$props.padding,
        g = _this$props.backgroundImage,
        $ = _this$props.showBorder,
        v = _this$props.showDropShadow,
        w = _this$props.shadowStrong,
        x = _this$props.tabIndex,
        I = _this$props["data-track"],
        C = _this$props["data-track-ignore"],
        y = _this$props["data-analyticstrack"],
        S = _this$props["data-clickstream"],
        _ = _this$props.href,
        D = _this$props.target,
        B = _this$props.ariaLabel,
        M = _this$props.role,
        O = _this$props.grouped,
        z = c() || !1,
        j = !(!h && !_);
      return e(b, Object.assign({
        surface: l,
        $mobile: z,
        $isInteractive: j,
        width: s
      }, !z && {
        onMouseEnter: function onMouseEnter() {
          return t._setHovered(!0);
        },
        onMouseLeave: function onMouseLeave() {
          return t._setHovered(!1);
        }
      }, {
        $hovered: this.state.hovered,
        $showDropShadow: v,
        $shadowStrong: w,
        height: a,
        children: [o(f, Object.assign({
          role: M || (h ? "button" : _ ? "link" : void 0),
          onClick: h ? this._onClick : void 0,
          "aria-label": B,
          tabIndex: j ? x : void 0,
          href: _
        }, !!_ && {
          target: D
        }, {
          primitive: _ ? "a" : "div",
          onKeyDown: this._onKeyDown,
          surface: l,
          $isInteractive: j,
          $active: this.state.active,
          $mobile: z,
          id: "OuterButton-".concat(this.tileContainerId),
          "data-track": I,
          "data-track-ignore": C,
          "data-analyticstrack": y,
          "data-clickstream": S,
          onMouseDown: this._onMouseDown,
          onMouseUp: this._onMouseUp,
          $hovered: this.state.hovered,
          children: !h && B ? B : ""
        })), o(k, {
          $active: this.state.active,
          $isInteractive: j,
          id: this.tileContainerId,
          $mobile: z,
          $backgroundColor: n,
          $imageFallbackColor: r,
          height: a,
          width: s,
          $aspectRatio: d || "1:1",
          padding: p,
          surface: l,
          $backgroundImage: g,
          background: i,
          $showBorder: $,
          $showDropShadow: v,
          $shadowStrong: w,
          children: o(m, {
            id: "inner-".concat(this.tileContainerId),
            width: s,
            $showBorder: $,
            padding: p,
            $isSafari: this.isSafari,
            $isIos: this.isIos,
            $isChrome: this.isChrome,
            $grouped: O,
            children: u
          })
        })]
      }));
    }
  }]);
  return x;
}(p);
x.defaultProps = {
  backgroundColor: "secondary",
  imageFallbackColor: "light",
  surface: "light",
  width: "100%",
  onClick: void 0,
  showDropShadow: !1,
  shadowStrong: !1,
  showBorder: !1,
  padding: "30px",
  backgroundImage: void 0,
  background: void 0,
  aspectRatio: "1:1",
  tabIndex: 0,
  target: "_self"
};
export { x as default };